import { c as _c } from "react/compiler-runtime";
import ArrowRightIcon from '@precis-digital/kurama/icons/ArrowRightIcon';
import Button from '@precis-digital/kurama/Button';
import Divider from '@precis-digital/kurama/Divider';
import EditIcon from '@precis-digital/kurama/icons/EditIcon';
import { styled } from '@precis-digital/kurama/utils';
import Typography from '@precis-digital/kurama/Typography';
import React, { type Dispatch, type SetStateAction } from 'react';
import { Role } from 'shared/components/Role';
import { UnStyledRetainDefaultQueryLink } from 'shared/components/Router';
import PERMISSIONS from 'shared/constants/permissions';
import { useAuth } from 'shared/context/AuthContext';
import { useCurrentClient } from 'shared/context/ClientContext';
import { APP_ROUTES } from 'shared/routes';
import { useTranslation } from 'shared/translations';
import { useQueryMember } from '../../api';
import { StyledCard, StyledCardContent, StyledFlyoutContainer, StyledFlyoutFooter, StyledFullWidthButton } from './styles';
import WorkspaceProfile from './WorkspaceProfile';
interface WorkspaceFlyoutProps {
  handleFlyout: Dispatch<SetStateAction<boolean>>;
  isAdminWorkspaceProfile: boolean;
  setIsAdminWorkspaceProfile: Dispatch<SetStateAction<boolean>>;
  uploadAvatarProps: {
    uploadAvatar: (file: File) => Promise<void>;
    isUploading: boolean;
    isUploadSuccess: boolean;
  };
}
const WorkspaceOverviewFlyout = t0 => {
  const $ = _c(11);
  const {
    handleFlyout,
    isAdminWorkspaceProfile,
    setIsAdminWorkspaceProfile,
    uploadAvatarProps
  } = t0;
  const {
    currentClient
  } = useCurrentClient();
  const {
    currentUser
  } = useAuth();
  const {
    data: currentMember
  } = useQueryMember(currentClient.id, currentUser?.id);
  const {
    t
  } = useTranslation("workspace");
  let t1;
  if ($[0] !== handleFlyout) {
    t1 = () => {
      handleFlyout(false);
    };
    $[0] = handleFlyout;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleNavigateAway = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Divider />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== currentClient || $[4] !== currentMember?.role || $[5] !== handleNavigateAway || $[6] !== isAdminWorkspaceProfile || $[7] !== setIsAdminWorkspaceProfile || $[8] !== t || $[9] !== uploadAvatarProps) {
    t3 = <StyledFlyoutContainer>{t2}{!isAdminWorkspaceProfile ? <><UnStyledRetainDefaultQueryLink href={APP_ROUTES.workspace.membersPage}><StyledCard onClick={handleNavigateAway}><StyledCardContent><Typography variant="h3">{t("titles.members")}</Typography></StyledCardContent><StyledButtonContainer><Button onClick={handleNavigateAway} variant="tonal"><ArrowRightIcon /></Button></StyledButtonContainer></StyledCard></UnStyledRetainDefaultQueryLink><UnStyledRetainDefaultQueryLink href={APP_ROUTES.workspace.notificationSettingsPage}><StyledCard onClick={handleNavigateAway}><StyledCardContent><Typography variant="h3">{t("titles.notificationSettings")}</Typography></StyledCardContent><StyledButtonContainer><Button onClick={handleNavigateAway} variant="tonal"><ArrowRightIcon /></Button></StyledButtonContainer></StyledCard></UnStyledRetainDefaultQueryLink><StyledFlyoutFooter><Role authorizedMemberRoles={PERMISSIONS.EDIT_PROFILE_WORKSPACE} memberRole={currentMember?.role}><Divider /><StyledFullWidthButton variant="filled" leftIcon={<EditIcon />} onClick={() => {
              setIsAdminWorkspaceProfile(true);
            }}>{t("buttons.editWorkspace")}</StyledFullWidthButton></Role></StyledFlyoutFooter></> : <WorkspaceProfile uploadAvatarProps={uploadAvatarProps} currentClient={currentClient} />}</StyledFlyoutContainer>;
    $[3] = currentClient;
    $[4] = currentMember?.role;
    $[5] = handleNavigateAway;
    $[6] = isAdminWorkspaceProfile;
    $[7] = setIsAdminWorkspaceProfile;
    $[8] = t;
    $[9] = uploadAvatarProps;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
const StyledButtonContainer = styled('div')(({
  theme
}) => ({
  button: {
    padding: 0,
    div: {
      marginRight: '0px'
    }
  }
}));
export default WorkspaceOverviewFlyout;